import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Typography,
} from "@mui/material";
import { StyledDialogTitle } from "../common/StyledDialogTitle";
import { get_expense_category } from "../../features/expense/expenseCategoryService";
import CommonInputField from "../common/InputField/CommonInputField";


interface IProps {
  handleClose: () => void;
  initialData?: any;
}

interface Category {
  id: number;
  name: string;
}
const ViewExpenseModal = ({ handleClose, initialData }: IProps) => {
  const [catData, setCatData] = useState<Category[]>([]);
  const expenseForm = {
    expensename: initialData?.name || "",
    date: (initialData?.expense_date?.split("T")[0]),
    exp_category: initialData?.exp_category?.name || "",
    amount: initialData?.amount || 0,
    description: initialData?.description || "",
  };

  const getCategory = async () => {
    try {
      const res = await get_expense_category();
      setCatData(res?.data.expense_categories || []);
    } catch (error: any) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "460px",
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: 24,
          position: "relative",
        }}
      >
        <StyledDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          isDone={false}
        >
          View Expense Details
        </StyledDialogTitle>

        <Divider />
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", gap: 2, px: 2, pb: 2 }}>
            <Box sx={{ flex: 1 }}>
              <CommonInputField
                label="Expense Name"
                value={expenseForm.expensename}
                onChange={() => {}}
                readOnly
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#333333",
                  mb: 0.5,
                }}
              >
                Date
              </Typography>
              <CommonInputField
                type="date"
                label=""
                value={expenseForm.date}
                onChange={() => {}}
                readOnly
              />
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 2, px: 2, pb: 2 }}>
            <Box sx={{ flex: 1 }}>
              <CommonInputField
                label="Expense Category"
                value={expenseForm.exp_category}
                onChange={() => {}}
                readOnly
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <CommonInputField
                label="Amount"
                value={`${expenseForm.amount.toString()} PKR`}
                onChange={() => {}}
                readOnly
              />
            </Box>
          </Box>

          <Box sx={{ px: 2, mb: 5 }}>
            <CommonInputField
              label="Description"
              value={expenseForm.description}
              multiline
              rows={3}
              onChange={() => {}}
              readOnly
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewExpenseModal;
